module.exports = __webpack_public_path__ + "img/dsci0156.3ca3bccc.jpg";